import React, { useEffect, useRef } from 'react';
export const Portfolio = () => {
  const companies = [{
    name: 'Databricks',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754428735/Databricks_White_Large_cmbvsn.png',
    height: 60 // Doubled from 30
  }, {
    name: 'Groq',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ttK9tA93iuqza2yEHR6sMy/Groq_White_Large.png',
    height: 60 // Doubled from 30
  }, {
    name: 'PLAY.AI',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8uSwFxeQJVkHBLPmcRuMPw/playai.png',
    height: 60 // Doubled from 30
  }, {
    name: 'Goodnotes',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754432034/Goodnotes_White_Logo_ov9hvp.png',
    height: 60 // Doubled from 30
  }, {
    name: 'Clerk Chat',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754425497/Clerk_White_Large_hs6hcs.png',
    height: 60 // Doubled from 30
  }, {
    name: 'Vectara',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754936326/Vectara_White_Large_st1oba.png',
    height: 60 // Doubled from 30
  }, {
    name: 'Skypilot',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754429401/Skypilot_White_Large_dimtjc.png',
    height: 60 // Doubled from 30
  }, {
    name: 'Opaque',
    logo: 'https://res.cloudinary.com/dtycj98cm/image/upload/v1754428735/opaque_white_large_nos7uc.png',
    height: 60 // Doubled from 30
  }];
  // Duplicate the companies array to create a seamless loop
  const allCompanies = [...companies, ...companies];
  const carouselRef = useRef(null);
  useEffect(() => {
    const carousel = carouselRef.current;
    if (!carousel) return;
    // Reset animation when it completes
    const handleAnimationEnd = () => {
      carousel.style.animation = 'none';
      carousel.offsetHeight; // Trigger reflow
      carousel.style.animation = null;
    };
    carousel.addEventListener('animationend', handleAnimationEnd);
    return () => {
      carousel.removeEventListener('animationend', handleAnimationEnd);
    };
  }, []);
  return <section className="w-full pt-7 pb-20 px-6 md:px-12 bg-white overflow-hidden transition-colors" data-id="element-72">
      <div className="max-w-7xl mx-auto" data-id="element-73">
        <div className="relative w-full" data-id="element-74">
          <style jsx data-id="element-75">{`
            @keyframes scroll {
              0% {
                transform: translateX(0);
              }
              100% {
                transform: translateX(-50%);
              }
            }
            .carousel {
              display: flex;
              width: fit-content;
              animation: scroll 30s linear infinite;
            }
            .carousel:hover {
              animation-play-state: paused;
            }
          `}</style>
          <div ref={carouselRef} className="carousel" data-id="element-76">
            {allCompanies.map((company, index) => <div key={index} className="flex-shrink-0 mx-2 w-[360px] h-[160px] flex items-center justify-center" data-id="element-77">
                <img src={company.logo} alt={`${company.name} logo`} className="max-w-[320px] object-contain" style={{
              height: `${company.height}px`,
              maxHeight: '100%',
              width: 'auto'
            }} data-id="element-78" />
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};